<!-- [팝업] 관련 질환 항목 설정 -->
<template>
  <b-modal
    v-model="showDeskDiseaseManage"
    cancel-variant="outline-secondary"
    centered
    ok-title="추가"
    cancel-title="닫기"
    size="lg"
    title="관련 질환 항목 설정"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="add()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row class="mt-1">
      <b-table
        ref="refDiseaseTable"
        primary-key="id"
        :items="fetchDisease"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        class="position-relative"
      >
        <template #cell(edit)="data">
          <span
            class="badge badge-light-primary"
            @click.prevent="edit(data.item)"
          > 수정 </span>
        </template>
        <template #cell(remove)="data">
          <span
            class="badge badge-light-danger"
            @click.prevent="remove(data.item)"
          > 삭제 </span>
        </template>
      </b-table>
    </b-row>
    <desk-disease-edit
      :is-new="deskDiseaseIsNew"
      :edit-item="deskDiseaseItem"
      :show-desk-disease-edit="showDeskDiseaseEdit"
      @close="deskDiseaseEdit.close"
    />
  </b-modal>
</template>

<script>
import axios from '@axios'
import { ref, onMounted, getCurrentInstance } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'
import { cloneDeep } from 'lodash'
import DeskDiseaseEdit from './DeskDiseaseEdit.vue'

export default {
  components: {
    DeskDiseaseEdit,
  },

  props: {
    showDeskDiseaseManage: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      // fetchCodes()
    })

    const toast = useToast()
    const instance = getCurrentInstance()
    const bvModal = instance.proxy.$bvModal
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    // Main Table Config
    const refDiseaseTable = ref(null)
    const sortBy = ref('createDate')
    const isSortDesc = ref(true)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: 'disease', label: '질환 항목', sortable: false, thStyle: { width: '600px' },
      },
      {
        key: 'edit', label: '수정', sortable: false, thStyle: { textAlign: 'center' },
      },
      {
        key: 'remove', label: '삭제', sortable: false, thStyle: { textAlign: 'center' },
      },
    ]

    const isRefetch = ref(false)
    const refetchData = () => {
      refDiseaseTable.value.refresh()
    }
    // Main Table Config End.

    const fetchDisease = (ctx, callback) => {
      axios.post('/fa/desk-disease/list', {
        search: {},
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터 조회에 실패하였습니다."))
        })
    }

    const deskDiseaseIsNew = ref(false)
    const deskDiseaseItem = ref(null)
    const showDeskDiseaseEdit = ref(false)
    const deskDiseaseEdit = {
      close: rs => {
        showDeskDiseaseEdit.value = false
        if (rs) {
          isRefetch.value = true
          refetchData()
        }
      },
    }

    const add = () => {
      deskDiseaseEdit.item = null
      deskDiseaseIsNew.value = true
      showDeskDiseaseEdit.value = true
    }

    const edit = item => {
      deskDiseaseItem.value = cloneDeep(item)
      deskDiseaseIsNew.value = false
      showDeskDiseaseEdit.value = true
    }

    const remove = item => {
      bvModal
        .msgBoxConfirm("삭제 하시겠습니까?", {
          size: "sm",
          cancelVariant: "outline-secondary",
          centered: true,
        })
        .then(confirm => {
          if (!confirm) return

          axios
            .delete(`/fa/desk-disease/${item.id}`)
            .then(() => {
              pushToast('success', '데이터 삭제 완료')
              isRefetch.value = true
              refetchData()
            })
            .catch(error => {
              const { response: { status, data } } = error
              if (status === 400 && data === 'ADM_PST_TP04') {
                pushToast('danger', `'${item.disease}'으로 설정된 게시글이 있어 삭제할 수 없습니다.`)
              } else {
                pushToast('danger', errorFormatter(error, "삭제하는 과정에서 오류가 발생하였습니다."))
              }
            })
        })
    }

    const close = () => {
      emit('close', isRefetch.value)
    }

    return {
      add,
      edit,
      remove,
      close,
      refDiseaseTable,
      sortBy,
      isSortDesc,
      totalRecords,
      tableColumns,
      refetchData,
      fetchDisease,
      showDeskDiseaseEdit,
      deskDiseaseEdit,
      deskDiseaseIsNew,
      deskDiseaseItem,
    }
  },
}
</script>
